const getInputPosition = (event: MouseEvent | TouchEvent | PointerEvent) => {
  if ('TouchEvent' in window && event instanceof TouchEvent) {
    const touchEvent = event.touches[0] || event.changedTouches[0];

    if (touchEvent) {
      return { x: touchEvent.pageX, y: touchEvent.pageY };
    }
  }

  if ('MouseEvent' in window && event instanceof MouseEvent) {
    return { x: event.pageX, y: event.pageY };
  }

  if ('PointerEvent' in window && event instanceof PointerEvent) {
    return { x: event.pageX, y: event.pageY };
  }

  return { x: 0, y: 0 };
};

export default getInputPosition;
